import React from 'react';
import loading_blue from '../assets/gif/loading_blue.gif';
import {getData, LOGIN} from "../util/storage";
import {isEmpty} from "../util/utility";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export const USER = "user"
export const BROADCASTER = "broadcaster"

export const renderField = ({input, label, type, email, username, is_password, share, shareList, password_class, buttonClick, disabled, height = 47, maxLength, minDate, maxDate, minTime, maxTime, isDatePicker, count, disabledDatePicker, hideMaxLength, min, max, meta: {touched, error, warning, initial}}) => {

    return (
        <div className="form-group">
            {
                (label.length > 0) && < label> {label}</label>
            }

            {
                is_password ?
                    <div className="input-group" style={{height: height}}>
                        <input className="form-control" {...input} type={type}/>
                        <div className="input-group-append">
                            <button className={password_class} type="button" name={input.name + '_btn'}
                                    onClick={buttonClick}>
                            </button>
                        </div>
                    </div>
                    : (
                        username ?
                            <div className="input-group" style={{height: height}}>
                                <input className="form-control" {...input} type={type}/>
                                {
                                    (username !== null && username.isFetching) &&
                                    <div className="input-group-append" style={{height: 35}}>
                                        <img src={loading_blue} alt={"Loading"} width={26} height={26}/>
                                    </div>
                                }
                            </div>
                            :
                            disabled ?
                                <div className="input-group" style={{height: height}}>
                                    <input className="form-control" {...input} style={{"backgroundColor": "#fff"}}
                                           type={type}
                                           disabled/>
                                    <div className="input-group-append">
                                        <button className={password_class} type="button" onClick={buttonClick}>Show Password
                                        </button>
                                    </div>
                                </div>
                                :
                                share ?
                                    <div className="input-group" style={{height: height}}>
                                        <input className="form-control" {...input} type={type}/>
                                        <div className="input-group-append">
                                            <div className={"popover__wrapper btn-controls "}>
                                                <button className="popover_share_title btn" type="button"
                                                        name={input.name + '_btn'}
                                                        onClick={buttonClick}>
                                                </button>
                                                <div className={"popover_share_content"}>
                                                    <ul
                                                        className="popover_menucontent"
                                                        aria-labelledby="myDropdown">
                                                        {shareList && shareList.map((shareData,index) => {
                                                            return <li style={{display: "inline-block"}} key={`share-key-${index}`}>
                                                                <a>{shareData}</a>
                                                            </li>
                                                        })}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    isDatePicker ?
                                        <div className="input-group" style={{height: height}}>
                                            <DatePicker
                                                className="form-control"
                                                dateFormat="Pp"
                                                timeIntervals={30}
                                                selected={input.value ? input.value : input.name === "start_time" ? new Date() : null}
                                                onChange={input.onChange}
                                                showTimeSelect={true}
                                                dateFormat="d/MM/yyyy h:mm aa"
                                                timeFormat={'hh:mm aa'}
                                                minTime={minTime}
                                                maxTime={maxTime}
                                                minDate={minDate}
                                                maxDate={maxDate}
                                                disabledKeyboardNavigation={true}
                                                disabled={disabledDatePicker}
                                            />
                                        </div>
                                        :
                                        <div className="input-group" style={{height: height}}>
                                            {maxLength ?
                                                <>
                                                    <input className="form-control" {...input} maxLength={maxLength}
                                                           type={type}/>
                                                    {
                                                        !hideMaxLength &&
                                                        <div className="character-count"
                                                             style={{zIndex: 9}}>
                                                            <span>{count}</span>/{maxLength} characters</div>
                                                    }
                                                </>
                                                :
                                                <input className="form-control" {...input} type={type} min={min}
                                                       max={max}/>}
                                        </div>
                    )

            }

            {/*{*/}
            {/*disabled &&*/}
            {/*<div className="input-group" style={{height: 47}}>*/}
            {/*<input className="form-control" {...input} style={{"backgroundColor": "#fff"}} type={type} disabled/>*/}
            {/*<div className="input-group-append">*/}
            {/*<button className={password_class} type="button" onClick={buttonClick}>Show Password*/}
            {/*</button>*/}
            {/*</div>*/}
            {/*</div>*/}

            {/*}*/}

            {
                (!error && (username !== null && username.username !== null) &&
                    ((username.username.status_code !== 200) ?
                        <span className="text-danger">{username.username.message}</span> :
                        <span className="text-success">{username.username.message}</span>))
            }
            {touched &&
            ((error && <span className="text-danger">{error}</span>) ||
                (warning && <span className="text-warning">{warning}</span>))}
        </div>

    )
};

export const renderTextAreaField = ({
                                        input,
                                        height,
                                        label,
                                        type,
                                        count,
                                        minLength = 10,
                                        maxLength = 280,
                                        meta: {touched, error, warning}
                                    }) => (

    <div className="form-group">
        {
            (label.length > 0) && < label> {label}</label>
        }
        <textarea className="form-control" {...input} maxLength={maxLength} style={{height:height}}></textarea>
        <div className="character-count"><span>{count}</span>/{maxLength} characters</div>
        {touched &&
        ((error && <span style={{position: 'absolute'}} className="text-danger">{error}</span>) ||
            (warning && <span style={{position: 'absolute'}} className="text-warning">{warning}</span>))}
        {((count > 0) && (count < minLength) &&
            <span style={{position: 'absolute'}} className="text-danger">Minimum characters {minLength}</span>)}
    </div>

);


export const checkIfRegister = (props) => {
    return (
        props.hasOwnProperty("account_management") &&
        props.account_management.hasOwnProperty("register") &&
        props.account_management.register !== null &&
        props.account_management.register.hasOwnProperty("status_code")
    )
}

export const checkIfTwoFactorAuth = (props) => {
    return (
        props.hasOwnProperty("account_management") &&
        props.account_management.hasOwnProperty("twoFactorAuth") &&
        props.account_management.twoFactorAuth !== null &&
        props.account_management.twoFactorAuth.hasOwnProperty("status_code")
    )
}

export const checkIfTwoFactorAuthVerifyOtp = (props) => {
    return (
        props.hasOwnProperty("account_management") &&
        props.account_management.hasOwnProperty("twoFactorAuthVerifyOtp") &&
        props.account_management.twoFactorAuthVerifyOtp !== null &&
        props.account_management.twoFactorAuthVerifyOtp.hasOwnProperty("status_code")
    )
}

export const checkIfLoggedIn = (props) => {
    return (
        props.hasOwnProperty("account_management") &&
        props.account_management.hasOwnProperty("login") &&
        props.account_management.login !== null &&
        props.account_management.login.hasOwnProperty("status_code")
    )
}

export const checkIfForgotPassword = (props) => {
    return (
        props.hasOwnProperty("account_management") &&
        props.account_management.hasOwnProperty("forgotPassword") &&
        props.account_management.forgotPassword !== null &&
        props.account_management.forgotPassword.hasOwnProperty("status_code")
    )
}

export const checkIfUserDataAvailable = (props) => {
    return (
        props.hasOwnProperty("account_management") &&
        props.account_management.hasOwnProperty("userDetails") &&
        props.account_management.userDetails !== null
    )
}

export const getUserDetail = (props, type, key1,key2 = null) => {

    if (checkIfUserDataAvailable(props)) {
        if (type === USER) {
            if(key2 === null){
                return props.account_management.userDetails[key1];
            }else{
                return props.account_management.userDetails[key1][key2];
            }
        } else if (type === BROADCASTER) {
            if (props.account_management.userDetails.broadcaster.length > 0) {
                return props.account_management.userDetails.broadcaster[0][key1];
            }
        }
        else {
            return props.account_management.userDetails
        }
    }
    return '';
}

export const getUserDetailsFromAPI = (props) => {

    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getUserDetails(data.token, data.api_token);
            }
        })
}

export const passwordObject = {
    current_password_btn: {
        type: 'current_pwd_type',
        class_name: 'current_pwd_class_name'
    },
    new_password_btn: {
        type: 'new_password_pwd_type',
        class_name: 'new_password_class_name'
    },
    confirm_password_btn: {
        type: 'confirm_password_pwd_type',
        class_name: 'confirm_password_class_name'
    },
    default: {
        type: 'type',
        class_name: 'class_name'
    }
}
